import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TableComponent } from './table/table.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { SelectComponent } from './select/select.component';
import { InputComponent } from './input/input.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { MatRadioModule } from '@angular/material/radio';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonExportToExcelComponent } from './button-export-to-excel/button-export-to-excel.component';
import { SelectMultipleComponent } from './select-multiple/select-multiple.component';
import { UpdateScrollerComponent } from './update-scroller/update-scroller.component';
import { UpdateScrollerCardComponent } from './update-scroller-card/update-scroller-card.component';
import { TabComponent } from './tab/tab.component';
import { CardComponent } from './card/card.component';
import { BadgeComponent } from './badge/badge.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { SegmentedButtonComponent } from './segmented-button/segmented-button.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { PaginationComponent } from './pagination/pagination.component';
import { MatInputModule } from '@angular/material/input';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DisplayDashPipe } from './pipes/display-dash.pipe';
import { ReplaceHlgtTagPipe } from './pipes/replace-hlgt-tag.pipe';
import { SelectSingleComponent } from './select-single/select-single.component';
import { MatDividerModule } from '@angular/material/divider';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { TextAreaComponent } from './text-area/text-area.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FilesUploadComponent } from './files-upload/files-upload.component';
import { DonutChartComponent } from './donut-chart/donut-chart.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FilePreviewComponent } from './file-preview/file-preview';
import { TooltipDirective } from './directives/tooltip.directive';
import { BannerComponent } from './banner/banner.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { BallotTypeBadgeComponent } from './status-badge/ballot-type-badge/ballot-type-badge.component';
import { BallotStatusBadgeComponent } from './status-badge/ballot-status-badge/ballot-status-badge.component';
import { CommitteeStatusBadgeComponent } from './status-badge/committee-status-badge/committee-status-badge.component';
import { AlertComponent } from './alert/alert.component';

@NgModule({
  declarations: [
    InputComponent,
    LoadingIndicatorComponent,
    SelectComponent,
    TableComponent,
    RadioGroupComponent,
    ButtonExportToExcelComponent,
    SelectMultipleComponent,
    UpdateScrollerComponent,
    UpdateScrollerCardComponent,
    TabComponent,
    CardComponent,
    BadgeComponent,
    StatusBadgeComponent,
    SegmentedButtonComponent,
    BackToTopComponent,
    PaginationComponent,
    DatePickerComponent,
    DisplayDashPipe,
    ReplaceHlgtTagPipe,
    SelectSingleComponent,
    TextAreaComponent,
    FilesUploadComponent,
    DonutChartComponent,
    FilePreviewComponent,
    TooltipDirective,
    BannerComponent,
    DateFormatPipe,
    ClickOutsideDirective,
    BallotTypeBadgeComponent,
    BallotStatusBadgeComponent,
    CommitteeStatusBadgeComponent,
    AlertComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatProgressSpinner,
    MatRadioModule,
    MatSortModule,
    MatTableModule,
    MatDateFnsModule,
    MatDatepickerModule,
    MatDividerModule,
    FontAwesomeModule,
    MatProgressBarModule,
    MatCheckboxModule
  ],
  exports: [
    InputComponent,
    LoadingIndicatorComponent,
    SelectComponent,
    TableComponent,
    RadioGroupComponent,
    ButtonExportToExcelComponent,
    SelectMultipleComponent,
    UpdateScrollerComponent,
    UpdateScrollerCardComponent,
    TabComponent,
    CardComponent,
    BadgeComponent,
    StatusBadgeComponent,
    SegmentedButtonComponent,
    PaginationComponent,
    BackToTopComponent,
    DatePickerComponent,
    DisplayDashPipe,
    ReplaceHlgtTagPipe,
    SelectSingleComponent,
    TextAreaComponent,
    FilesUploadComponent,
    DonutChartComponent,
    TooltipDirective,
    BannerComponent,
    DateFormatPipe,
    ClickOutsideDirective,
    BallotTypeBadgeComponent,
    BallotStatusBadgeComponent,
    CommitteeStatusBadgeComponent,
    AlertComponent
  ]
})


export class ControlsModule { }
